var visa_checkout_button = (function ($) {

    function hijackHandler(type, prePayment, handler) {
        var _this = this;
        if (type === 'click') {
            var a = arguments;
            prePayment().then(function () {
                handler.apply(_this, a);
            });
        } else {
            handler.apply(_this, arguments);
        }
    }

    function hijackEvent(element, prePayment) {
        var addEvent;
        if (element.addEventListener) {
            addEvent = element.addEventListener.bind(element);
            element.addEventListener = function (type, handler) {
                addEvent(type, function () {
                    hijackHandler.bind(this, type, prePayment, handler)();
                }, false);
            }
        } else if (element.attachEvent) {
            addEvent = element.attachEvent.bind(element);
            element.attachEvent = function (type, handler) {
                addEvent("on" + type, function () {
                    hijackHandler.bind(this, type, prePayment, handler)();
                });
            }
        }
    }

    function _subscribe(button, cb) {
        cb && hijackEvent(button[0], cb);

        this.resizeButton &&
            $(window).resize(function () {
                button.prop('src', getButtonImgWithSize());
            });

        button[0].reInit = function () {
            var $clone = button.clone();
            button.replaceWith($clone);
            _subscribe($clone, cb);
        }
    };

    function _getButtonImgWithSize(url) {
        var url = url || 'https://assets.secure.checkout.visa.com/';
        url = url.replace(/\/$/, '') + '/';
        return url + 'wallet-services-web/xo/button.png?width=' + (window.innerWidth/2 - 20) + '&height=47';
    };

    function getbutton(data, cb, url, tmplName, buttonSize) {
        var getButtonImgWithSize = _getButtonImgWithSize;
        data.src = _getButtonImgWithSize(url);
		var button = $.tmpl(tmplName || 'bt-checkout-button-visa', data);

        _subscribe(button, cb);

        if (buttonSize) {
            button.css('width', buttonSize + 'px');
        }

        return button;
    }

    return {
        appendButtonTo: function ($element, data, cb, url, buttonSize) {
            $element.empty().append(getbutton(data, cb, url, null, buttonSize));
        },

        replaceWith: function ($element, data, cb, url) {
            $element.replaceWith(getbutton(data, cb, url));
        },

		getbutton: function (data, cb, url, tmplName) {
			return getbutton(data, cb, url, tmplName);
        }
    };

})(jQuery);